import { render, staticRenderFns } from "./ChannelsTab.vue?vue&type=template&id=352e951c&scoped=true&"
import script from "./ChannelsTab.vue?vue&type=script&lang=ts&"
export * from "./ChannelsTab.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelsTab.vue?vue&type=style&index=0&id=352e951c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e951c",
  null
  
)

export default component.exports